export default __webpack_public_path__ + "static/media/lady.6c3fd3cd.png";